// @flow
import type { Reducer } from 'redux';
import omit from '../utils/omit.js';

import {
  GET_TRANSACTIONS,
  BUY_TRANSACTION,
  EDIT_TRANSACTION,
  ADD_OFFLINE,
  ADD_CREDIT,
  SAVE_CREDIT,
  DELETE_CREDIT
} from './transaction.const.js';
import { GET_INVOICES } from "../invoice/invoice.const";

export const transactions = (
  state: $ElementType<ReduxState, 'transactions'> = {},
  action: Action
) => {
  switch (action.type) {
    case GET_TRANSACTIONS:
    case GET_INVOICES:
      if (!Array.isArray(action.payload.transactions)) {
        return action.payload.transactions;
      }
      return state;
    case BUY_TRANSACTION:
    case ADD_OFFLINE:
    case ADD_CREDIT:
    case SAVE_CREDIT:
      return {
        ...state,
        [action.payload.transaction.id]: action.payload.transaction
      };
    case EDIT_TRANSACTION:
      if (action.payload.transaction.trash) {
        return omit(state, action.payload.transaction.id);
      }

      return {
        ...state,
        // [action.payload.transaction.id]: action.payload.transaction,
        // TODO: need server get editable, deletable
        [action.payload.transaction.id]: {
          ...state[action.payload.transaction.id],
          ...action.payload.transaction
        }
      };
    default:
      return state;
  }
};

export const transactionsList = (state: List = [], action: Action) => {
  switch (action.type) {
    case GET_TRANSACTIONS:
      return action.payload.transactionsList;
    case GET_INVOICES:
      if (action.payload.transactions) {
        return Object.keys(action.payload.transactions)
          .map(transactionId => parseInt(transactionId, 10))
      }
      return state;
    case EDIT_TRANSACTION:
      if (action.payload.transaction.trash) {
        return state.filter(id => id !== action.payload.transaction.id);
      }
      return state;
    default:
      return state;
  }
};

export const paymentTransactionsList = (state: List = [], action: Action) => {
  switch (action.type) {
    case EDIT_TRANSACTION:
      if (action.payload.transaction.trash) {
        return state.filter(id => id !== action.payload.transaction.id);
      }
      return state;
    default:
      return state;
  }
};

export const credits = (state: $ElementType<ReduxState, 'credits'> = {}, action: Action) => {
  switch (action.type) {
    case ADD_CREDIT:
      return {
        ...state,
        [action.payload.transaction.id]: action.payload.transaction
      };
    case SAVE_CREDIT:
      return {
        ...state,
        [action.payload.transaction.id]: action.payload.transaction
      };
    case DELETE_CREDIT:
      return omit(state, action.payload.transaction.id);
    default:
      return state;
  }
};

export const URL = (state: $ElementType<ReduxState, 'URL'> = {}) => state;

export const offlineTypes = (state: $ElementType<ReduxState, 'offlineTypes'> = {}) => state;
